import React, { Component, Fragment } from 'react'
import DashboardLayout from '../../components/Admin/DashboardLayout.jsx'
import { MDBContainer, MDBIcon } from 'mdb-react-ui-kit'
import MDB4Datatable from '../../components/content/MDB4Datatable/MDB4Datatable.component'
import { toast } from 'react-toastify'

class AdminReports extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      pagination: { page: 0, per_page: 10 },
    }
  }

  render() {
    toast.configure()

    const data = {
      columns: [
        {
          label: 'Report Name',
          field: 'name',
          sort: 'asc',
          width: 150,
        },
        {
          label: 'View Report',
          field: 'view',
          sort: 'asc',
          width: 270,
        },
      ],
      rows: [
        {
          name: 'Completed Signature Agents',
          view: (
            <a href='completed-sig-agents'>
              <MDBIcon icon='binoculars' size='2x' className='d-flex justify-content-center blue-text' />
            </a>
          ),
        },
        {
          name: 'Conference Qualifiers',
          view: (
            <a href='conference-qualifiers'>
              <MDBIcon icon='binoculars' size='2x' className='d-flex justify-content-center blue-text' />
            </a>
          ),
        },
        {
          name: 'Factors Milestones',
          view: (
            <a href='factor-milestones'>
              <MDBIcon icon='binoculars' size='2x' className='d-flex justify-content-center blue-text' />
            </a>
          ),
        },
        {
          name: 'Wheel of Love',
          view: (
            <a href='wheel-of-love'>
              <MDBIcon icon='heart' size='2x' className='d-flex justify-content-center red-text' />
            </a>
          ),
        },
        {
          name: 'Promo Code Redemptions',
          view: (
            <a href='promo-code-redemptions'>
              <MDBIcon icon='binoculars' size='2x' className='d-flex justify-content-center blue-text' />
            </a>
          ),
        },
        {
          name: 'Users Report',
          view: (
            <a href='user-reports'>
              <MDBIcon icon='binoculars' size='2x' className='d-flex justify-content-center blue-text' />
            </a>
          ),
        },
      ],
    }

    return (
      <Fragment>
        <DashboardLayout>
          <main className='mainSection pb-5'>
            <MDBContainer fluid className='mt-5'>
              <h2>Admin Reports</h2>
              <hr />
              <div className='content-wrapper'>
                <MDB4Datatable data={data} striped bordered small order={['name', 'asc']} />
              </div>
            </MDBContainer>
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default AdminReports
